<div class="c-time">
  <div class="c-time__container mb-8">
    <p500-ui-icon name="timestamps"></p500-ui-icon>
    <div class="c-time__container" #currentTimeElement></div>
  </div>
  <div class="c-time__container">
    <p500-ui-icon name="domains"></p500-ui-icon>
    <span>+00:00, UTC</span>
  </div>
</div>
